import * as Yup from 'yup';

import {
  DEVICE_NAME_REQUIRED_MESSAGE,
  EXPECTED_PAYLOAD_INTERVAL_MIN_MESSAGE,
  EXPECTED_PAYLOAD_INTERVAL_TYPE_MESSAGE,
} from './config/streamLiteFormDefaults';

const StreamLiteGatewaySchema = Yup.object().shape({
  general: Yup.object().shape({
    deviceName: Yup.string()
      .trim()
      .min(1, DEVICE_NAME_REQUIRED_MESSAGE)
      .required(DEVICE_NAME_REQUIRED_MESSAGE),
    expectedPayloadInterval: Yup.number()
      .nullable()
      .transform((value, originalValue) =>
        typeof originalValue === 'string' && originalValue.trim() === '' ? null : value
      )
      .min(1, EXPECTED_PAYLOAD_INTERVAL_MIN_MESSAGE)
      .typeError(EXPECTED_PAYLOAD_INTERVAL_TYPE_MESSAGE),
  }),
  ioTags: Yup.object().shape({
    tags: Yup.array(),
  }),
});

export { StreamLiteGatewaySchema };
